import { render, staticRenderFns } from "./multipledb.vue?vue&type=template&id=7f481417&scoped=true&"
import script from "./multipledb.vue?vue&type=script&lang=js&"
export * from "./multipledb.vue?vue&type=script&lang=js&"
import style0 from "./multipledb.vue?vue&type=style&index=0&id=7f481417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f481417",
  null
  
)

export default component.exports